export default __webpack_public_path__ + "static/media/01_DAIF_Data_04_01.d4e8ba24.mp4";